import { Card } from "@mui/material"

function UploadHeader({ children }) {
  return <Card elevation={1} square className="upload-card upload-stepper-wrapper">
    {children}
  </Card>
}

export default UploadHeader
